import Textarea from './Textarea'
import Input from './Input'
import MarginOptions from './MarginOptions'
import RightBarGroup from './RightBarGroup'
import ImageOptions from './ImageOptions'
import {
  ChangeEvent,
  DynamicContentType,
  FileEntryBM,
  ImageData,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<ImageData>
  setData: (e: ChangeEvent<string | FileEntryBM | undefined>) => void
}

const ImageEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()
  return (
    <>
      <Input
        type='image'
        label={tr(TrKey.imageEditorImageLabel)}
        value={content.data.file}
        setter={(f) =>
          setData({
            target: {
              name: 'file',
              value: f,
            },
          })
        }
      />
      <Textarea
        light
        label={tr(TrKey.imageEditorImageTextLabel)}
        desc={tr(TrKey.imageEditorImageTextDescription)}
        id='imageText'
        name='imageText'
        value={content.data.imageText}
        onChange={setData}
      />
      <RightBarGroup title={tr(TrKey.imageEditorImageSettingsTitle)} topLine>
        <ImageOptions content={content} setData={setData} />
      </RightBarGroup>
      <MarginOptions setData={setData} content={content} />
    </>
  )
}

export default ImageEditor
